import React from 'react';
import Icon from 'v2/components/Icon';
import Box from 'v2/components/UI/Box';
import ButtonBase from 'v2/components/UI/ButtonBase';
import Text from 'v2/components/UI/Text';
import useMenu from './hooks/useMenu';

//TODO: REFACTOR IN UPDATE REACT
const Menu: React.FC = () => {
  const { isExpanded, menuItems, toggleExpandedMenu } = useMenu();

  return (
    <Box
      width={isExpanded ? '220px' : '70px'}
      flexDirection="column"
      transition="width 0.3s ease"
      background={'#30bf9b30'}
      height={'100vh'}
      borderRadius={18}
      padding={5}
    >
      <ButtonBase
        width="100%"
        justifyContent={isExpanded ? 'flex-start' : 'center'}
        alignItems="center"
        gap={isExpanded ? 10 : 0}
        borderRadius={12}
        padding={15}
        onClick={toggleExpandedMenu}
      >
        <Icon
          iconName={isExpanded ? 'ChevronLeft' : 'ChevronRight'}
          size={26}
          htmlColor="#005f47"
        />

        <Text color="#005f47" fontSize={16}>
          {isExpanded && 'Ações'}
        </Text>
      </ButtonBase>

      <Box height={1} background="#005f472d" margin={'4px 0'} />

      {menuItems.map((item) => (
        <ButtonBase
          key={item.id}
          width="100%"
          justifyContent={isExpanded ? 'flex-start' : 'center'}
          alignItems="center"
          gap={isExpanded ? 10 : 0}
          borderRadius={12}
          padding={'10px 15px'}
          onClick={item.onClick}
        >
          <Icon iconName={item.icon} size={26} htmlColor="#005f47" />

          <Text color="#005f47" fontSize={16}>
            {isExpanded && item.label}
          </Text>
        </ButtonBase>
      ))}
    </Box>
  );
};

export default Menu;
